import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import Card from "react-bootstrap/Card";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData, Select2Data, getDimension, IMG_URL } = useContext(Context);
  const [courseUniversity, setCourseUniversity] = useState([]);


  const id = props.show;

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });




  const GetEditData = async () => {
    const response = await getData(`/masters/specialization/${id}`);
    console.log(response?.data);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset,
    watch,
  } = useForm();
  console.log(getValues());
  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      console.log("data", data);
      const fromData = new FormData();
      fromData.append("name", data?.name);
      fromData.append("url", data?.url);
      fromData.append("meta_title", data?.meta_title);
      fromData.append("meta_description", data?.meta_description);
      fromData.append("alt_tag", data?.alt_tag);
      fromData.append("canonical_tag", data?.canonical_tag);
      fromData.append("keyword", data?.keyword);
      fromData.append("course_university_id", data?.course_university_id?.value);

      fromData.append("image", data?.image[0]);
      const response = await postData(`/masters/specialization/${id}`, fromData);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetAllCourseUniversity = async () => {
    const response = await getData("/allCourseUniversity");

    if (response?.success) {
      setCourseUniversity(await Select2Data(response?.data, "course_course_university_id"));
    }
  };

  const SelectData = async (data, name, other = false) => {
    const result = data.map((data) => ({
      value: data?.id,
      label: `${data?.university?.name} - ${data?.ed_tech_course?.name}`,
      name: name,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };


  useEffect(() => {
    GetAllCourseUniversity();
  }, []);
  return (
    <>
      <Modal
        onHide={props.handleClose}
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit specialization
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            className="countryclass"
          >
            <Row>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>University-Course</Form.Label>

                    <Controller
                      name="course_university_id" // name of the field
                      {...register("course_university_id", {
                        required: "course_university is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.course_university_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={courseUniversity}
                        />
                      )}
                    />

                    {errors.course_university_id && (
                      <span className="text-danger">
                        {errors.course_university_id.message}
                      </span>
                    )}
                  </Row>
                </div>

                <div className="main-form-section mt-3">

                  <Form.Label >
                    Specialization
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      type="text"
                      {...register("name", {
                        required: "Title is required",
                      })}
                      placeholder="Title"
                    />
                  </Form.Group>
                  {errors.name && (
                    <span className="text-danger">
                      {errors.name.message}
                    </span>
                  )}

                </div>

                <div className="main-form-section mt-3">

                  <Form.Label >
                    URL
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.url,
                      })}
                      type="text"
                      {...register("url", {
                        required: "URL is required",
                      })}
                      placeholder="URL"
                    />
                  </Form.Group>
                  {errors.url && (
                    <span className="text-danger">
                      {errors.url.message}
                    </span>
                  )}

                </div>

                <div className="main-form-section mt-3">

                  <Form.Label >
                    Meta Title
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.meta_title,
                      })}
                      type="text"
                      {...register("meta_title", {
                        // required: "Title is required",
                      })}
                      placeholder="Meta Title"
                    />
                  </Form.Group>

                </div>

                <div className="main-form-section mt-3">

                  <Form.Label >
                    Meta Description
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.meta_description,
                      })}
                      type="text"
                      {...register("meta_description", {
                        // required: "Title is required",
                      })}
                      placeholder="Meta Description"
                    />
                  </Form.Group>

                </div>

                <div className="main-form-section mt-3">

                  <Form.Label >
                    Alt Tag
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.alt_tag,
                      })}
                      type="text"
                      {...register("alt_tag", {
                        // required: "Title is required",
                      })}
                      placeholder="Alt Tag"
                    />
                  </Form.Group>

                </div>

                <div className="main-form-section mt-3">

                  <Form.Label >
                    Canonical Tag
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.canonical_tag,
                      })}
                      type="text"
                      {...register("canonical_tag", {
                        // required: "Title is required",
                      })}
                      placeholder="Canonical Tag"
                    />
                  </Form.Group>

                </div>

                <div className="main-form-section mt-3">

                  <Form.Label >
                    Keywords <sub>(comma seperated)</sub>
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.keyword,
                      })}
                      type="text"
                      {...register("keyword", {
                        // required: "Title is required",
                      })}
                      placeholder="Keywords"
                    />
                  </Form.Group>

                </div>

                <div className="main-form-section mt-3">

                  <Form.Label >
                    Image
                  </Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.image,
                      })}
                      type="file"
                      {...register("image", {
                        validate: async (value) => {
                          console.log(value);
                          if (typeof value !== "string") {
                            const fileTypes = ["jpg", "png", "jpeg", "JPG"];
                            const fileType = value[0]?.name?.split(".")[1];

                            if (!fileTypes.includes(fileType)) {
                              // return `please upload a valid file format. (${fileTypes})`;
                            }


                          }
                        },
                      })}
                      accept=".jpg, .jpeg, .png"
                    />
                  </Form.Group>
                  {errors.image && (
                    <span className="text-danger">
                      {errors.image.message}
                    </span>
                  )}

                </div>
              </Col>

              {/* Image Preview */}
              <Col lg={6}>
                <div className="main-form-section mt-3">

                  <Form.Label >
                    Image Preview
                  </Form.Label>

                  {typeof getValues("image") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IMG_URL + getValues("image")}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )
                  )}

                </div>
              </Col>
            </Row>

            {/* Buttons */}
            <Row className="justify-content-center mt-5 pb-3">
              <Col sm={6} className="d-flex justify-content-center">
                <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                <SaveButton
                  name={"Save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
